import { Component, HostListener } from '@angular/core';
import { ObservableService } from '@modweb5/sharedServices/observableService/observable-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'COO';

	constructor(
		private observableService: ObservableService
	) {
	}

	@HostListener('window:keydown', ['$event'])
		keyEvent(event: KeyboardEvent) {
			this.observableService.emitKeydown(event);
		}

	@HostListener('window:resize', ['$event'])
		onResize(event) {
			this.observableService.emitWindowResize(event);
		}

}
